import React, { useState } from 'react';
import BiddingUserAuth from './BiddingUserAuth';
import { useAccountVerificationStatus } from '../../hooks/useAccountVerificationStatus';
import { useSelector } from 'react-redux';
import { isLoggedInSelector } from '~/App/shared/selectors/sessionSelector';
import BiddingUserAccountVerification from './BiddingUserAccountVerification';

interface Props {
  setAuthInUse: (inUse: boolean) => void;
  isBiddingObject: boolean;
}

const BiddingViewAuthAndVerification = ({
  setAuthInUse,
  isBiddingObject
}: Props) => {
  const isLoggedIn = useSelector(isLoggedInSelector);
  const [shouldKeepAuthMounted, setShouldKeepAuthMounted] = useState(false);
  const { accountVerificationStatus, pendingStatuses } =
    useAccountVerificationStatus();

  if (!isLoggedIn || shouldKeepAuthMounted) {
    return (
      <BiddingUserAuth
        setAuthInUse={setAuthInUse}
        setShouldKeepAuthMounted={setShouldKeepAuthMounted}
      />
    );
  }
  if (accountVerificationStatus) {
    return (
      <BiddingUserAccountVerification
        setAuthInUse={setAuthInUse}
        isBiddingObject={isBiddingObject}
        accountVerificationStatus={accountVerificationStatus}
        pendingStatuses={pendingStatuses}
      />
    );
  }

  return null;
};

export default BiddingViewAuthAndVerification;
